import { render, staticRenderFns } from "./solutionList.vue?vue&type=template&id=c459e8c6&"
import script from "./solutionList.vue?vue&type=script&lang=ts&"
export * from "./solutionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports